export default __webpack_public_path__ + "img/6.asset.f32aca80.jpeg";